import type { MutationConfig } from "apps/visits/core/lib/react-query";
import { useMutation } from "react-query";
import { useGetSlug } from "../store/use-config";
import { GroupActionsOrderingRepository } from "./group-actions-ordering.api";

const groupActionsOrderingRepository = new GroupActionsOrderingRepository();

type UseCreateSessionOptions = {
  config?: MutationConfig<typeof groupActionsOrderingRepository.createSession>;
};

export const useCreateSession = ({ config }: UseCreateSessionOptions) => {
  const slug = useGetSlug();

  return useMutation({
    ...config,
    mutationFn: (data) => groupActionsOrderingRepository.createSession(data, slug),
  });
};
